export default class ImageZoom {
  constructor(component) {
    this.viewport = component.viewport;
    this.images = component.images;
    this.imageId = null;
    this.$el = null;
    this.zoomArea = null;
    this.zoomAreaContainer = null;

    this.setVariables();


    this.prepareZoom();
  }

  _unbindEvents() {
    if (this.zoomAreaContainer) {
      this.zoomAreaContainer.off('click');
    }

    if (this.zoomArea) {
      this.zoomArea.off('mouseout');
      this.zoomArea.off('mousemove');
    }
  }

  setVariables() {
    const currentImage = this.viewport.querySelector('[data-product-gallery-selected="true"] img');
    if (!currentImage) {
      this.imageId = null;
      this.$el = null;
      this.zoomArea = null;
      this.zoomAreaContainer = null;
      return;
    }

    this.imageId = currentImage.getAttribute('data-image-zoom');
    this.$el = $(this.images[this.imageId]);
    this.zoomArea = $(this.viewport.querySelector(`[data-product-zoom-id="${this.imageId}"]`));
    this.zoomAreaContainer = $(this.viewport.querySelector(`[data-media="${this.imageId}"] .product-gallery--media-wrapper`));

    this.zoomAreaContainer.on('click', this.toggleZoom.bind(this));
    this.zoomArea.on('mouseout', this.toggleZoom.bind(this));
    this.zoomArea.on('mousemove', this.zoomImage.bind(this));
  }

  prepareZoom(resetVariables) {
    if (resetVariables) {
      this._unbindEvents();
      this.setVariables();
    }

    if (!this.imageId) return;

    const imageSource = this.$el.attr('src');
    const photoAreaWidth = this.zoomAreaContainer.width();
    const photoAreaHeight = this.zoomAreaContainer.height();

    const newImage = new Image();

    $(newImage).on('load', () => {
      this.zoomImageWidth = newImage.width;
      this.zoomImageHeight = newImage.height;

      const ratios = new Array();
      ratios[0] = this.zoomImageWidth / photoAreaWidth;
      ratios[1] = this.zoomImageHeight / photoAreaHeight;

      const ratio = Math.max(...ratios);

      // Only enable the zoom if a certain zooming ratio is met.
      if (ratio < 1.4) {
        this.zoomAreaContainer.removeClass('zoom-enabled');
      } else {
        this.zoomAreaContainer.addClass('zoom-enabled');

        return this.zoomArea.css({
          backgroundImage: `url(${imageSource})`,
        });
      }
    });

    return newImage.src = imageSource;
  }

  toggleZoom(e) {
    if (this.zoomAreaContainer.hasClass('zoom-enabled')) {
      if (e.type === 'mouseout') {
        this.zoomArea.removeClass('active');
        return;
      }

      this.zoomArea.toggleClass('active');

      return this.zoomImage(e);
    }
  }

  zoomImage(e) {
    const zoomWidth = this.zoomArea.width();
    const zoomHeight = this.zoomArea.height();

    const bigImageOffset = this.zoomAreaContainer.offset();
    const bigImageX = Math.round(bigImageOffset.left);
    const bigImageY = Math.round(bigImageOffset.top);

    const mousePositionX = e.pageX - bigImageX;
    const mousePositionY = e.pageY - bigImageY;

    // Make sure our mouse position is still inside our box.
    if ((mousePositionX < zoomWidth)
      && (mousePositionY < zoomHeight)
      && (mousePositionX > 0)
      && (mousePositionY > 0)) {
      if (this.zoomArea.hasClass('active')) {
        // Figure out how to position the zoomed image.
        let ratioX = Math.round(((mousePositionX / zoomWidth) * this.zoomImageWidth) - (zoomWidth / 2)) * -1;
        let ratioY = Math.round(((mousePositionY / zoomHeight) * this.zoomImageHeight) - (zoomHeight / 2)) * -1;

        if (ratioX > 0) { ratioX = 0; }
        if (ratioY > 0) { ratioY = 0; }

        if (ratioX < -(this.zoomImageWidth - zoomWidth)) {
          ratioX = -(this.zoomImageWidth - zoomWidth);
        }
        if (ratioY < -(this.zoomImageHeight - zoomHeight)) {
          ratioY = -(this.zoomImageHeight - zoomHeight);
        }

        const newBackgroundPosition = `${ratioX}px ${ratioY}px`;

        return this.zoomArea.css({
          backgroundPosition: newBackgroundPosition,
        });
      }
    }
  }
}
